<template>
  <div>
    <v-dialog v-model="editDialog" width="830" @input="closeEdit">
      <v-form ref="form" v-model="valid" v-on:submit.prevent>
        <v-card>
          <v-card-text class="border-bottom">
            <div class="row pt-1 border-bottom">
              <div class="col-md-12">
                <div class="d-flex justify-space-between align-center mt-2">
                  <SvgIcon class="text-2xl font-semibold" text="Add Sales Person" style="color: black">
                  </SvgIcon>
                  <v-btn fab x-small class="shadow-0" @click="closeEdit">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <v-row dense class="mt-6">
              <div class="col-md-3">
                <div style="height: 150px">
                  <image-uploader
                      @upload="(data) => { user.image = data; }"
                      @remove="() => { user.profile_image = null; }"
                      :image_path="user.profile_image"
                      text="Customer Picture "
                      messagePosition="inside"
                      messageText=""
                  ></image-uploader>
                </div>
              </div>
              <div class="col-md-9">
                <div class="row row--dense">
                  <div class="col-md-6">
                    <label for="">First Name </label>
                    <v-text-field
                        v-model="user.first_name"
                        :rules="[maxLengthRule]"
                        class="q-text-field shadow-0" outlined dense hide-details="auto"
                    ></v-text-field>
                  </div>
                  <div class="col-md-6">
                    <label for="">Last Name</label>
                    <v-text-field
                        v-model="user.last_name"
                        class="q-text-field shadow-0" outlined dense
                        hide-details="auto"
                    ></v-text-field>
                  </div>

                  <div class="col-md-6">
                    <label for="">Mobile Number </label>
                    <mobile-number-field
                        v-model="user.mobile"
                        :refresh-country="true"
                        required
                        :variant="1"
                        :dense="true"
                        :outlined="true"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="">Email </label>
                    <v-text-field
                        class="q-text-field shadow-0" outlined dense
                        validate-on-blur
                        hide-details="auto"
                        v-model="user.email"


                        :rules="[
                                        (v) => !!v || 'Email is required',
                                        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                                        ]"
                    ></v-text-field>
                  </div>

                  <div class="col-md-6">
                    <label for="">Username </label>
                    <v-text-field
                        class="q-text-field shadow-0"
                        outlined
                        dense
                        type="text"
                        hide-details="auto"
                        v-model="user.username"
                        :rules="[(v) => !!v || 'Username is required']"
                        autocomplete="off"
                    />
                  </div>
                  <div class="col-md-6" v-if="!user.id">
                    <label for="">Password </label>
                    <v-text-field
                        class="q-text-field shadow-0"
                        outlined
                        dense
                        v-model="user.password"
                        :required="!user.id"
                        :rules="user.id?[]:[(v) => !!v || 'Password is required']"
                        type="password"
                        hide-details="auto"
                        autocomplete="off"
                    ></v-text-field>
                  </div>
                  <div class="col-md-6">
                    <label for="">Commission </label>
                    <v-text-field
                        class="q-text-field shadow-0"
                        outlined
                        dense
                        prefix="%"
                        type="number"
                        hide-details="auto"
                        v-model="user.commission_pct"
                        :rules="[(v) => !!v || 'Commission is required']"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="">Status</label>
                    <v-select
                        class="q-text-field shadow-0"
                        outlined
                        dense
                        hide-details="auto"
                        :menu-props="{ bottom: true, offsetY: true }"
                        item-value="id"
                        item-text="name"
                        :items="[{id: 1, name: 'Active'},{id: 2, name: 'Deactive'}]"
                        v-model="user.status_id"
                        :rules="[(v) => !!v || 'Status is required']"
                        validate-on-blur
                    ></v-select>
                  </div>
                </div>
              </div>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color=" "
                class="ma-2  "
                text
                @click="closeEdit"
            > Close
            </v-btn>
            <v-btn
                color=" darken-1"
                class="ma-2 white--text blue-color"
                @click="saveSalesPerson"
                text
            >Save
            </v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
// import moment from "moment";
import ImageUploader from "@/components/Image/ImageUploader.vue";
import MobileNumberField from "@/components/Fields/MobileNumberField.vue";
import SvgIcon from "@/components/Image/SvgIcon.vue";

export default {
  components: {
    MobileNumberField,
    ImageUploader,
    SvgIcon,
  },
  props: {
    userID: {type: Number, default: null},
    type: {type: String, default: "details"},
    isPermissionCheck: {type: Boolean, default: true},
    editDialog: {type: Boolean, default: false},
    userData:{ type:Object, default:null}
  },
  data() {
    return {
      userModel: false,
      image: null,
      valid: false,
      user: {},
    };
  },
  watch:{
    editDialog: {
      immediate: true,
      handler() {
        this.edituser();
      },
    }
  },
  computed: {
    maxLengthRule() {
      return (v) => (v && v.length <= 50) || 'Maximum 50 characters allowed'
    },
  },
  methods: {
    edituser(){
      if(this.userData){
        this.user = this.userData
      }
    },
    closeEdit() {
      this.user = {};
      this.$emit("close");
    },
    saveSalesPerson(event) {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.showError("Please complete all required fields");
        return;
      }
      let formData = new FormData();
      formData.set("first_name", this.user.first_name);
      formData.set("last_name", this.user.last_name);
      if (this.user.password != null) {
        formData.set("password", this.user.password);
      }
      if (this.user.email != null) {
        formData.set("email", this.user.email);
      }
      if (this.user.image) {
        formData.set("image", this.user.image);
      }
      formData.set("mobile", this.user.mobile);
      formData.set("commission_pct", this.user.commission_pct);
      formData.set("status_id", this.user.status_id);
      formData.set("username", this.user.username);
      this.showLoader("Verifying and saving credentials");
      this.$http({
        url: "sales-team" + (this.user.id ? `/${this.user.id}` : ""), method: "POST", data: formData,
        headers: {"Content-Type": "multipart/form-data; boundary=${form._boundary}",},
      }).then((response) => {
        if (response.status === 200) {
          this.showSuccess("Person Saved Successfully.");
          this.user = {};
          this.closeEdit();
        }
      }).catch((error) => {
        this.errorChecker(error);
      }).finally(() => {
        this.hideLoader();
      });
    },
  },
};
</script>

<style scoped>
.personal-trainer_ic {
  padding: 10px;
  background-size: contain;
}

.credit_table table thead tr th {
  background: #066a8c !important;
  color: #fff !important;
}

.history_table thead {
  background-color: #ccc;
}

.history_table thead th {
  padding: 5px;
}
</style>
  